export enum DateFormat {
  MonthDayYear = 1,
  DayMonthYear = 2,
  YearMonthDay = 3
}